import { request } from '@/utils/request';
import { useWalletAddress } from './useWalletAddress';

export function useLocale() {
  const address = useWalletAddress();

  const fetchWorldCoinUserLogin = async () => {
    try {
      const response = await request(
        `${process.env.VITE_BASE_URL}/api/world-coin-users/login`,
        {
          method: 'POST',

          body: JSON.stringify({
            wallet: address,
            enableNoti: false,
            locale: navigator.language || 'en-US',
          }),
        },
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log('API Response:', data);
    } catch (error) {
      console.error('Error fetching world coin user login:', error);
    }
  };

  return { fetchWorldCoinUserLogin };
}
